import type { RootState } from '../../../Store';

const getState = (state: RootState) => state.MerchantState.payouts.history;

export default {
	getState,
};
